import { render } from "./VerpackungszubehoerPage.vue?vue&type=template&id=40082756"
import script from "./VerpackungszubehoerPage.vue?vue&type=script&lang=js"
export * from "./VerpackungszubehoerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__